import { gsap } from 'gsap'
import Swiper, { EffectFade, Autoplay, Pagination } from 'swiper'
import 'swiper/css'
import 'swiper/css/effect-fade'
import 'swiper/css/autoplay'
import 'swiper/css/pagination'

export class OpencampusKV {
  constructor() {
    if (document.getElementById('js-opencampus_kv') === null) return
    const opencampusKvAnim = () => {
      const tl = gsap.timeline()
      tl.fromTo(
        '.p-opencampus_kv__slider',
        {
          opacity: 0,
          onComplete: () => {
            let slider = document.getElementById('js-opencampus_kv')
            slider.classList.add('is-act')
          },
        },
        { opacity: 1 }
      )
      tl.fromTo('.p-opencampus_kv__obj.-circle', { opacity: 0, scale: 1.05, x: -10, y: 10 }, { opacity: 1, scale: 1, x: 0, y: 0, delay: 0.5 })
      tl.fromTo('.p-opencampus_kv__obj.-dot', { opacity: 0, scale: 1.05, x: 15, y: 10 }, { opacity: 1, scale: 1, x: 0, y: 0 }, '<')
      tl.fromTo('.p-opencampus_kv__title', { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.4 })
    }

    window.addEventListener('load', () => {
      opencampusKvAnim()
    })

    let opencampusSlider = new Swiper('#js-opencampus_kv', {
      modules: [EffectFade, Autoplay, Pagination],
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      speed: 2000,
      autoplay: {
        delay: 3000,
      },
      pagination: {
        el: '#js-opencampus_dot',
        type: 'bullets',
      },
    })
  }
}
